import React from "react";
import { getSpecializationTitle } from "../constants/specializations.js";

export interface StatAlertRowProps {
  alertId: number;
  specialization: string;
  weeklyCount: number;
  monthlyCount: number;
}

export function StatAlertRow({
  alertId,
  specialization,
  weeklyCount,
  monthlyCount,
}: StatAlertRowProps): React.ReactElement {
  return (
    <div
      data-testid={`stat-row-${alertId}`}
      style={{
        backgroundColor: "var(--color-paper)",
        borderRadius: "var(--radius-card)",
        boxShadow: "var(--shadow-floating)",
        padding: "16px 20px",
        marginBottom: "12px",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <h3
            style={{
              margin: 0,
              fontSize: "16px",
              fontWeight: 600,
              color: "var(--color-graphite)",
            }}
          >
            {getSpecializationTitle(specialization)}
          </h3>
        </div>

        <div style={{ display: "flex", gap: "16px", textAlign: "right" }}>
          <div>
            <div style={{ fontSize: "16px", fontWeight: 700, color: "var(--color-graphite)" }}>
              {weeklyCount}
            </div>
            <div style={{ fontSize: "11px", color: "var(--color-slate)" }}>7 дней</div>
          </div>
          <div>
            <div style={{ fontSize: "16px", fontWeight: 700, color: "var(--color-graphite)" }}>
              {monthlyCount}
            </div>
            <div style={{ fontSize: "11px", color: "var(--color-slate)" }}>30 дней</div>
          </div>
        </div>
      </div>
    </div>
  );
}
